module.exports = __webpack_public_path__ + "static/media/landing-bg.9563ec38.jpg";